<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <!-- <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <CalendarRange v-model="datetimeRange" mode="date" />
              </div>
            </div> -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateFrom"
                  mode="date"
                  @input="onChangeDateFrom"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateTo"
                  mode="date"
                  @input="onChangeDateTo"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Dịch vụ</div>
                <!-- <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    multiple
                    collapse-tags
                    filterable
                    clearable
                    placeholder=""
                  >
                    <el-option
                      v-for="item in hotelOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div> -->

                <select-with-search-table
                  style="width: 100%"
                  index-field="sub_transaction_id"
                  :search-fields="[
                    'sub_transaction_code',
                    'sub_transaction_id_desc'
                  ]"
                  :selected-index-field-value="searchParams.subTransactionId"
                  :value="searchParams.subTransactionId"
                  :rows="serviceOptions"
                  :columns="serviceOptionsCols"
                  :dropdown-width="400"
                  :is-remove-btn="true"
                  @selectionChanged="onSelectService"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    <div>
                      <span
                        v-if="
                          selectedData?.sub_transaction_code &&
                          selectedData?.sub_transaction_desc
                        "
                      >
                        {{ selectedData.sub_transaction_code }}
                        {{ ` - ${selectedData.sub_transaction_desc}` }}
                      </span>
                    </div>
                  </template>
                </select-with-search-table>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIds"
                    multiple
                    collapse-tags
                    filterable
                    clearable
                    placeholder=""
                  >
                    <el-option
                      v-for="item in hotelOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box daily-trans-report">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                Báo cáo tổng hợp giao dịch theo ngày
              </span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel">
                    Xuất Excel
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="daily-trans__list">
            <el-collapse v-model="collapseNameList">
              <div
                v-for="dailyTrans in dailyTransDataList"
                :key="dailyTrans.id"
                class="daily-trans__item"
              >
                <el-collapse-item :name="dailyTrans.id">
                  <template slot="title">
                    <span class="daily-trans__item-header">
                      {{ 'Khách sạn:' }} {{ dailyTrans.hotel_name }}
                    </span>
                  </template>
                  <!-- <span class="daily-trans__item-header">
                    {{ dailyTrans.hotel_name }}
                  </span> -->
                  <div class="grid-scroll">
                    <!-- <GridVx
                    ref="agGrid"
                    :columns="columns"
                    :rows="rows"
                    class="agGrid"
                    :auto-size-cell="true"
                  /> -->
                    <GridVx
                      ref="agGrid"
                      :columns="columns"
                      :rows="dailyTrans.rows"
                      class="agGrid daily-trans-synthesis-grid"
                      :auto-size-cell="true"
                    />
                  </div>
                </el-collapse-item>
                <div class="daily-trans__item-footer">
                  {{ 'Tổng' }}: {{ $displayCurrency(dailyTrans.total_money) }}
                </div>
              </div>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Doanh thu: Doanh thu của từng loại dịch vụ được liệt kê</li>
            <li>Tổng: tổng doang thu của các loại dịch vụ được liệt kê</li>
            <li>
              Thánh toán: Các phương thức thanh toán được ở cấu hình > kế toán >
              Thanh toán > khách sạn
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import InfoBtn from '../components/InfoBtn.vue'
import { getAllHotel } from '@/api/hotel'
import { getSpecialServiceTransApi } from '@/api/Service_Policy/specialService'
import {
  getDailyTransactionSummaryReport,
  getDailyTransactionSummaryReportExcel
} from '@/api/report_service/report'
import moment from 'moment'
import { downFile } from '@/utils/file-handler'

// GRIDS
const cellClassRules = {
  'header-row': params => params.data?.rowClass === 'headerRow',
  'sum-row': params => params.data?.rowClass === 'sumRow'
}

const getDefaultSearchParams = () => ({
  dateFrom: moment().format('YYYY-MM-DD'),
  dateTo: moment().format('YYYY-MM-DD'),
  hotelIds: [],
  subTransactionId: null
})

export default {
  components: {
    CalendarRange,
    SelectWithSearchTable,
    InfoBtn,
    CalendarSelect
  },
  data() {
    return {
      dialogFormVisible: false,

      // SELECT OPTIONS
      hotelOptions: [],
      serviceOptions: [],
      serviceOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'sub_transaction_code',
          tooltipField: 'sub_transaction_code',
          flex: 1
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'sub_transaction_desc',
          tooltipField: 'sub_transaction_desc',
          flex: 2
        }
      ],

      loading: false,
      searchParams: getDefaultSearchParams(),
      columns: [
        // {
        //   field: 'groupCol',
        //   cellClass: 'grid-cell-centered',
        //   maxWidth: 100,
        //   rowGroup: true,
        //   hide: true,
        //   cellClassRules
        // },
        {
          headerName: this.$t('grid.column.service'),
          field: 'sub_transaction_desc',
          // cellClass: "grid-cell-centered",
          sortable: false,
          flex: 1,
          cellClassRules
        },
        {
          headerName: this.$t('grid.column.revenue'),
          field: 'money',
          flex: 1,
          // cellClass: "grid-cell-centered",
          // width: 100,
          valueGetter: params => this.$displayCurrency(params.data.money),
          tooltipValueGetter: params =>
            this.$displayCurrency(params.data.money),
          sortable: false,
          cellClassRules
        },
        {
          headerName: this.$t('grid.column.refund'),
          field: 'refund',
          valueGetter: params => this.$displayCurrency(params.data.refund),
          tooltipValueGetter: params =>
            this.$displayCurrency(params.data.refund),
          // cellClass: "grid-cell-centered",
          sortable: false,
          flex: 1,
          cellClassRules
        }
      ],
      rows: [],
      dailyTransDataList: [],

      collapseNameList: []
    }
  },
  async mounted() {
    await Promise.all([this.getHotelOptions(), this.getServiceOptions()])
    this.attachData()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onSearch() {
      this.attachData()
    },

    onReset() {
      this.searchParams = getDefaultSearchParams()
      this.datetimeRange = { start: null, end: null }

      this.attachData()
    },

    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },

    async getHotelOptions() {
      getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },

    async getServiceOptions() {
      getSpecialServiceTransApi({ transactionGroup: 1 }).then(res => {
        this.serviceOptions = res.data
      })
    },

    onSelectService(data) {
      this.searchParams.subTransactionId = data?.sub_transaction_id ?? null
    },

    /** Transfer dailyTransDataList for displaying in grid table */
    transferDataList(dataList) {
      class PaymentRow {
        constructor(label, money) {
          this.sub_transaction_desc = label
          this.money = money
          this.is_bottom = true
        }
      }

      const transferedDataList = []

      dataList.forEach(data => {
        const paymentRows = [
          new PaymentRow('Thẻ', data.card_total),
          new PaymentRow('Tiền mặt', data.cash_total),
          new PaymentRow('Chuyển khoản', data.transfer_total),
          new PaymentRow('Công nợ', data.debt_total),
          new PaymentRow('Miễn phí', data.free)
        ]

        const transferedData = {
          id: data.hotel_id,
          hotel_name: data.hotel_name,
          rows: [
            ...data.transactions,
            {
              sub_transaction_desc: 'Thanh toán',
              rowClass: 'headerRow'
            },
            ...paymentRows
          ],
          total_money:
            data.card_total +
            data.cash_total +
            data.transfer_total +
            data.debt_total +
            data.free
          // pinnedBottomRowData: [
          //   {
          //     sub_transaction_desc: 'Tổng',
          //     fee: '',
          //     is_bottom: true
          //   }
          // ]
        }

        transferedDataList.push(transferedData)

        // For Showing all item
        // this.collapseNameList.push(data.hotel_id)
      })

      return transferedDataList
    },

    async attachData() {
      const queryParams = {
        ...this.searchParams
      }

      getDailyTransactionSummaryReport(queryParams)
        .then(res => {
          this.dailyTransDataList = this.transferDataList(res.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    async downloadExcel() {
      const queryParams = {
        ...this.searchParams
      }

      getDailyTransactionSummaryReportExcel(queryParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(
            res,
            'bao_cao_tong_hop_giao_dich_theo_ngay_' + date + '.xlsx'
          )
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}

.daily-trans-report {
  --cell-border-color: rgba(189, 195, 199, 0.5);
  --ag-header-bg: #5f8b76;

  height: 100%;

  .daily-trans__list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
    overflow-y: auto;

    .el-collapse {
      border: 0 !important;
    }
  }

  .daily-trans__item {
    .el-collapse-item__header {
      background-color: #357456;
      color: #fff !important;
      border-bottom: 1px solid var(--cell-border-color);
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    &-header {
      font-weight: 600;
      flex: 1;
      font-size: 14px;
      padding: 0 12px;
    }

    &-footer {
      height: 34px;
      line-height: 34px;
      padding: 0 12px;
      background-color: #e7f6e5 !important;
      border-bottom: 1px solid var(--cell-border);
      margin-bottom: 2px;
      font-weight: 500;
      font-size: 14px;
    }

    .grid-scroll {
      // height: 400px;
      // max-height: 400px;
    }

    .daily-trans-synthesis-grid.agGrid {
      .header-row,
      .header-row:hover {
        background-color: var(--ag-header-bg) !important;
        color: white;
        font-weight: bold;
      }

      .ag-header-row-column {
        background-color: var(--ag-header-bg) !important;
      }
    }
  }
}
</style>
